/**
 * Notification bar — close button + 1-day cookie dismissal.
 *
 * The cookie is keyed by the notification's data-notification-key (a hash of
 * the current text) so changing the message re-shows the bar to users who
 * dismissed the previous version.
 */

const COOKIE_PREFIX = 'brinova_notification_dismissed_';

function getCookie(name) {
	const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
	return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
	const expires = new Date();
	expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
	document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
}

function initNotificationBar() {
	const bar = document.querySelector('.notification-bar');
	if (!bar) {
		return;
	}

	const key = bar.getAttribute('data-notification-key') || 'default';
	const cookieName = COOKIE_PREFIX + key;

	if (getCookie(cookieName)) {
		bar.remove();
		return;
	}

	const closeBtn = bar.querySelector('.notification-bar__close');
	if (closeBtn) {
		closeBtn.addEventListener('click', function () {
			setCookie(cookieName, '1', 1);
			bar.remove();
		});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initNotificationBar);
} else {
	initNotificationBar();
}
